import Switch from "react-switch";

import useToggleActive from './hooks/useToggleActive';
import './styles.scss';

const ToggleActive = ({ document, setToRefresh }) => {
  const { active, handleActive } = useToggleActive(document, setToRefresh);

  return (
    <div key={document?.ID} className="toggle__active">
      <label>Ativo:</label>

      <Switch
        checked={!!active}
        onChange={handleActive}
      />
    </div>
  );
};

export default ToggleActive;
